<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i">
<p class="titlehalf">IMAGES OF WAR</p>
<p class="title1"><span class="bold">JAPAN TRIUMPHANT</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?44beb330